import { useQuery } from 'react-query';

import AssessmentService from 'App/services/AssessmentService';

function useFetchTherapyAssessments(therapyId, showRetiredAssessments) {
    return useQuery(
        ['therapyAssessments', therapyId, 'showRetiredAssessments', showRetiredAssessments],
        () => {
            if (!therapyId) {
                return [];
            }
            return AssessmentService.getTherapyAssessments(therapyId, showRetiredAssessments);
        },
        {
            retry: false,
            refetchInterval: false,
            refetchOnWindowFocus: false,
        }
    );
}

export default useFetchTherapyAssessments;
